
import { PropTypes } from 'prop-types';
import { useEffect, useState } from 'react';
import { FaArrowRight } from 'react-icons/fa6';
import { motion } from 'framer-motion';
import ModelButton from '../modelBtn/modelButton';
const StudentLifeCard = ({ reverse, img, title, description, children }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);


    useEffect(()=>{
        if (typeof window !== 'undefined') {
            if (modalOpen) {
                document.body.style.overflow = "hidden";
                document.body.style.zIndex = "-1";
                document.querySelector("#root > div > div").classList.remove("z-30")
                document.querySelector("#root > div > div").classList.add("z-[5]")
               
            } else {
                document.body.style.overflow = "unset";
                document.body.style.zIndex = "unset";
                document.querySelector("#root > div > div").classList.add("z-30")
            }
        }
       },[modalOpen])




    return (
        <div className={`flex flex-col ${reverse ? "lg:flex-row-reverse" : "lg:flex-row"} gap-16 w-full lg:h-[20rem]  `}>
            <div className='w-full flex-1 h-full min-h-[20rem] bg-center bg-cover bg-no-repeat ' style={{ backgroundImage: `url('${img}')` }}>

            </div>
            <div className='flex w-full flex-col h-fit flex-1 items-start justify-between gap-5'>
                <h1 className="w-auto   text-slate-900 text-4xl font-bold uppercase">{title}</h1>
                <div className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal">{description}</div>
                {
                    children
                        ?
                        <>
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.9 }} className=" text-blue-700 justify-center items-center gap-4 flex"
                                onClick={() => (modalOpen ? closed() : open())}
                            >
                                <span className="text-base whitespace-nowrap font-bold capitalize flex items-center gap-3">Learn More <FaArrowRight /></span>
                            </motion.button>
                            <ModelButton modalOpen={modalOpen} close={closed}>
                                {children}
                            </ModelButton>
                        </>
                        :
                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.9 }} className=" text-blue-700 justify-center items-center gap-4 flex"
                        >
                            <span className="text-base whitespace-nowrap font-bold capitalize flex items-center gap-3">Learn More <FaArrowRight /></span>
                        </motion.button>

                }
            </div>

        </div>
    )
}
StudentLifeCard.propTypes = {
    reverse: PropTypes.bool,
    img: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.any,
    children: PropTypes.node
}
export default StudentLifeCard